import React from 'react';
import ReactDOM from 'react-dom/client';
import CalculatorApp from './components/Calculator/CalculatorApp';
import './components/Calculator/calculator.css'; // Global styles for calculator

// Specific entry point for Calculator using a lightweight app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <CalculatorApp />
    </React.StrictMode>
);
